//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockOnLocation', {
//        templateUrl: 'views/components/views/stockOnLocation/stockOnLocation.template.html?v=' + module.version, 
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'stockOnLocationService', 'ttGridFactory', 'layoutService', function ($stateParams, utilityService, stockOnLocationService, ttGridFactory, layoutService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockKeyno = $stateParams.stock_keyno;
//            let functionName = $stateParams.functionname;
//            let onDestroy = [];

//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                gridReady: false,
//            	setting: {},
//                itemsListStockOnLocations: []
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_stockonlocation_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS
    
//            async function loadSetting() {
//                vm.model.setting = (await stockOnLocationService.getStockOnLocation({
//                    stock_keyno: stockKeyno,
//                    functionname: functionName
//                }))[0];
//            }

//            async function loadStockOnLocations() {
//                if (utilityService.validateParmsValue(vm.model.setting.stock_keyno) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.functionname) !== true) return;

//                vm.model.itemsListStockOnLocations = await stockOnLocationService.listStockOnLocations({
//                    stock_keyno: vm.model.setting.stock_keyno,
//                    functionname: vm.model.setting.functionname
//                });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.stock_keyno) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.functionname) !== true) return;

//                vm.grid.dataTask.loadData = {
//                    method: 2577,
//                    parameters: {
//                        stock_keyno: vm.model.setting.stock_keyno,
//                        functionname: vm.model.setting.functionname
//                    }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON WINDOW RESIZE FUNCTION

//            async function onWindowResize() {
//                if (vm.model.tabletSize.matches === true) {
//                    loadGrid();
//                } else {
//                    loadStockOnLocations();
//                }
//            }

//            // #endregion ON WINDOW RESIZE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();

//                if (vm.model.tabletSize.matches === true) {
//                    loadGrid();
//                } else {
//                    loadStockOnLocations();
//                }

//            	window.addEventListener('resize', onWindowResize);
//            	onWindowResize();
//            }

//            // #endregion ON INIT FUNCTION

//            // #region DESTROY FUNCTION

//            vm.$onDestroy = function () {
//            	window.removeEventListener('resize', onWindowResize);

//            	onDestroy.forEach((fn) => {
//            		if (typeof fn === 'function') fn();
//            	});
//            }

//            // #endregion DESTROY FUNCTION

//        }]
//    });
//})();
